// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2VRPJ","footer":"ChangeClinic_footer__25u0U"};